module.exports = __webpack_public_path__ + "img/sec2.3.ffd58855.png";